import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keyJournals: BaseKeyFunction = () => ["journals"];

export type KeyJournalProps = { id: number };

export const keyJournal: BaseKeyFunction<KeyJournalProps> = ({ id }) => [
  "journals",
  id?.toString(),
];
